import React from 'react';

import AllFacilities from '../assets/svg/ico-allFacilities.svg';
import Arabic from '../assets/svg/ico-arabic.svg';
import Arrow from '../assets/svg/ico-arrow.svg';
import ArrowNext from '../assets/svg/arrow-next.svg';
import ArrowNextNew from '../assets/svg/arrow-next-new.svg';
import ArrowRoundedNext from '../assets/svg/arrow-rounded-next.svg';
import ArrowPrev from '../assets/svg/arrow-prev.svg';
import ArrowUp from '../assets/svg/arrow-up.svg';
import ArrowDown from '../assets/svg/arrow-down.svg';
import Avatar from '../assets/svg/ico-avatar.svg';
import Bus from '../assets/svg/ico-bus.svg';
import Bus2 from '../assets/svg/ico-bus2.svg';
import Calendar from '../assets/svg/ico-calendar.svg';
import Call from '../assets/svg/call.svg';
import Chat from '../assets/svg/chat.svg';
import Careem from '../assets/svg/ico-careem.svg';
import ChatBallon from '../assets/svg/ico-chatBallon.svg';
import Close from '../assets/svg/cross-icon.svg';
import CloseRounded from '../assets/svg/close-rounded.svg';
import Contact from '../assets/svg/ico-contact.svg';
import Download from '../assets/svg/download.svg';
import ExistingCompany from '../assets/svg/existing-company.svg';
import FilterArrow from '../assets/svg/filter-arrow.svg';
import Flag from '../assets/svg/ico-flag.svg';
import FoodBeverages from '../assets/svg/ico-foodBeverages.svg';
import FreeZone from '../assets/svg/free-zone.svg';
import FreeZoneCornerArrow from '../assets/svg/freezone-corner-left-arrow.svg';
import FreezoneServicesArrow from '../assets/svg/free-zone-services-arrow.svg';
import Grid from '../assets/svg/ico-grid.svg';
import HoldingHeart from '../assets/svg/ico-holdingHeart.svg';
import Hub from '../assets/svg/hub.svg';
import HubCompliance from '../assets/svg/hub-compliance.svg';
import HubLegalServices from '../assets/svg/hub-legal-services.svg';
import HubCallForwarding from '../assets/svg/hub-call-forwarding.svg';
import HubMailManagement from '../assets/svg/hub-mail-management.svg';
import HubProServices from '../assets/svg/hub-pro-services.svg';
import HubAccountTax from '../assets/svg/hub-account-tax.svg';
import HubGoldenVisa from '../assets/svg/hub-golden-visa.svg';
import House from '../assets/svg/ico-house.svg';
import LeftDownArrow from '../assets/svg/left-down-arrow.svg';
import List from '../assets/svg/ico-list.svg';
import Location from '../assets/svg/ico-location.svg';
import Location2 from '../assets/svg/ico-location2.svg';
import LocationThin from '../assets/svg/ico-locationThin.svg';
import ManAvatar from '../assets/svg/ico-manAvatar.svg';
import Map from '../assets/svg/ico-map.svg';
import Metro from '../assets/svg/ico-metro.svg';
import Mobile from '../assets/svg/ico-mobile.svg';
import NewCompany from '../assets/svg/new-company.svg';
import OrganiseStructure from '../assets/svg/ico-organiseStructure.svg';
import PaintingGallery from '../assets/svg/ico-paintingGallery.svg';
import Parking from '../assets/svg/ico-parking.svg';
import Parking2 from '../assets/svg/ico-parking2.svg';
import Pause from '../assets/svg/ico-pause.svg';
import PeopleChart from '../assets/svg/ico-peopleChart.svg';
import Play from '../assets/svg/ico-play.svg';
import Presentation from '../assets/svg/ico-presentation.svg';
import RetailServices from '../assets/svg/ico-retailServices.svg';
import RightArrowDown from '../assets/svg/right-down-arrow.svg';
import RoundCheck from '../assets/svg/round-tick.svg';
import Search from '../assets/svg/ico-search.svg';
import SearchDetails from '../assets/svg/ico-searchDetails.svg';
import Share from '../assets/svg/ico-share.svg';
import ShareArrow from '../assets/svg/ico-share-arrow.svg';
import Taxi from '../assets/svg/ico-taxi.svg';
import Taxi2 from '../assets/svg/ico-taxi2.svg';
import TexBallonLeft from '../assets/svg/ico-textBallonLeft.svg';
import TexBallonRight from '../assets/svg/ico-textBallonRight.svg';
import TextList from '../assets/svg/ico-textList.svg';
import Time from '../assets/svg/ico-time.svg';
import Train from '../assets/svg/ico-train.svg';
import Uber from '../assets/svg/ico-uber.svg';
import UberCareem from '../assets/svg/ico-uberCareem.svg';
import Venues from '../assets/svg/venues.svg';
import AboutDubai from '../assets/svg/about-dubai.svg';
import Accessibility from '../assets/svg/accessibility.svg';
import Facilitiesavailableatdwtc from '../assets/svg/facilities-available-at-dwtc.svg';
import Freezonelicenses from '../assets/svg/freezone-licenses.svg';
import FreeZoneSectionArrow from '../assets/svg/freezone-section-arrow.svg';
import FreezoneArrowUp from '../assets/svg/free-zone-arrow-up.svg';
import FreezoneArrowDown from '../assets/svg/free-zone-arrow-down.svg';
import Generalenquiriesaboutthevenue from '../assets/svg/general-enquiries-about-the-venue.svg';
import Hospitality from '../assets/svg/hospitality.svg';
import Hotels from '../assets/svg/hotels.svg';
import Howtogettodwtc from '../assets/svg/how-to-get-to-dwtc.svg';
import Importantcontactsatdwtc from '../assets/svg/important-contacts-at-dwtc.svg';
import Venueservices from '../assets/svg/venue-services-for-exhibitions.svg';
import Weddings from '../assets/svg/weddings.svg';
import Facebook from '../assets/svg/facebook.svg';
import Linkedin from '../assets/svg/linkedin.svg';
import Youtube from '../assets/svg/youtube.svg';
import TwitterX from '../assets/svg/twitter-x.svg';
import FreeZoneDownloadButton from '../assets/svg/freezone-download-button.svg';
import SingleFamilyOffice from '../assets/svg/single-family-office.svg';
import MultiFamilyOffice from '../assets/svg/multi-family-office.svg';
import Door from '../assets/svg/door.svg';
import Tick from '../assets/svg/tick.svg';
import Faq1 from '../assets/svg/icon-faq-1.svg';
import Faq2 from '../assets/svg/icon-faq-2.svg';
import Faq3 from '../assets/svg/icon-faq-3.svg';
import Faq4 from '../assets/svg/icon-faq-4.svg';
import Faq5 from '../assets/svg/icon-faq-5.svg';
import Faq6 from '../assets/svg/icon-faq-6.svg';
import Faq7 from '../assets/svg/icon-faq-7.svg';
import Faq8 from '../assets/svg/icon-faq-8.svg';
import Faq9 from '../assets/svg/icon-faq-9.svg';
import Faq10 from '../assets/svg/icon-faq-10.svg';
import Faq11 from '../assets/svg/icon-faq-11.svg';
import Toggle from '../assets/svg/toggle.svg';
import Filter from '../assets/svg/filter.svg';
import FilterBlack from '../assets/svg/filter-black.svg';
import ShowMore from '../assets/svg/show-more.svg';
import PersonHeadphone from '../assets/svg/person-headphone.svg';
import EmailChat from '../assets/svg/email-chat.svg';
import BusinessActivitiesLicenseType from '../assets/svg/business-activities-license-type.svg';
import AccountingTax from '../assets/svg/accounting-tax.svg'
import BankAccount from '../assets/svg/bank-account.svg'
import CallForwading from '../assets/svg/call-forwading.svg'
import CompilanceServices from '../assets/svg/compliance-services.svg'
import GoldenVisa from '../assets/svg/golden-visa.svg'
import LegalServices from '../assets/svg/legal-services.svg'
import MailManagement from '../assets/svg/mail-management.svg'
import ProServices from '../assets/svg/pro-services.svg'

export default function Sprites({ name = '', className = name, dataToggle = '' }) {
  const componentsArr = [
    { component: <AllFacilities className={className} />, name: 'allFacilities' },
    { component: <Arabic className={className} />, name: 'arabic' },
    { component: <Arrow className={className} />, name: 'arrow' },
    { component: <ArrowRoundedNext className={className} />, name: 'arrow-rounded-next' },
    { component: <ArrowNext className={className} />, name: 'arrownext' },
    { component: <ArrowNextNew className={className} />, name: 'arrownextnew' },
    { component: <ArrowPrev className={className} />, name: 'arrowprev' },
    { component: <ArrowDown className={className} />, name: 'arrow-down' },
    { component: <ArrowUp className={className} />, name: 'arrow-up' },
    { component: <Avatar className={className} />, name: 'avatar' },
    { component: <Bus className={className} />, name: 'bus' },
    { component: <Bus2 className={className} />, name: 'bus2' },
    { component: <Calendar className={className} />, name: 'calendar' },
    { component: <Call className={className} />, name: 'call' },
    { component: <Chat className={className} />, name: 'chat' },
    { component: <Careem className={className} />, name: 'careem' },
    { component: <ChatBallon className={className} />, name: 'chatBallon' },
    { component: <Close className={className} />, name: 'close' },
    { component: <CloseRounded className={className} />, name: 'close-rounded' },
    { component: <Contact className={className} />, name: 'contact' },
    { component: <Download className={className} />, name: 'download' },
    { component: <ExistingCompany className={className} />, name: 'existing-company' },
    { component: <Flag className={className} />, name: 'flag' },
    { component: <FilterArrow className={className} />, name: 'filter-arrow' },
    { component: <FoodBeverages className={className} />, name: 'foodBeverages' },
    { component: <FreeZone className={className} />, name: 'free-zone' },
    { component: <FreezoneArrowUp className={className} />, name: 'free-zone-arrow-up' },
    { component: <FreeZoneSectionArrow className={className} />, name: 'freezone-corner-arrow' },
    { component: <FreezoneArrowDown className={className} />, name: 'free-zone-arrow-down' },
    {
      component: <FreezoneServicesArrow className={className} />,
      name: 'free-zone-services-arrow',
    },
    {
      component: <FreeZoneCornerArrow className={className} />,
      name: 'freezone-corner-left-arrow',
    },
    {
      component: <FreeZoneDownloadButton className={className} />,
      name: 'freezone-download-button',
    },
    { component: <Grid className={className} />, name: 'grid' },
    { component: <HoldingHeart className={className} />, name: 'holdingHeart' },
    { component: <House className={className} />, name: 'house' },
    { component: <Hub className={className} />, name: 'hub' },
    { component: <LeftDownArrow className={className} />, name: 'left-down-arrow' },
    { component: <List className={className} />, name: 'list' },
    { component: <Location className={className} />, name: 'location' },
    { component: <Location2 className={className} />, name: 'location2' },
    { component: <LocationThin className={className} />, name: 'locationThin' },
    { component: <ManAvatar className={className} />, name: 'manAvatar' },
    { component: <Map className={className} />, name: 'map' },
    { component: <Metro className={className} />, name: 'metro' },
    { component: <Mobile className={className} />, name: 'mobile' },
    { component: <MultiFamilyOffice className={className} />, name: 'multi-family-office' },
    { component: <NewCompany className={className} />, name: 'new-company' },
    { component: <Door className={className} />, name: 'door' },
    { component: <OrganiseStructure className={className} />, name: 'organiseStructure' },
    { component: <PaintingGallery className={className} />, name: 'paintingGallery' },
    { component: <Parking className={className} />, name: 'parking' },
    { component: <Parking2 className={className} />, name: 'parking2' },
    { component: <Pause className={className} />, name: 'pause' },
    { component: <PeopleChart className={className} />, name: 'peopleChart' },
    { component: <Play className={className} />, name: 'play' },
    { component: <Presentation className={className} />, name: 'presentation' },
    { component: <RetailServices className={className} />, name: 'retailServices' },
    { component: <RightArrowDown className={className} />, name: 'right-arrow-down' },
    { component: <RoundCheck className={className} />, name: 'roundCheck' },
    { component: <Search className={className} />, name: 'search' },
    { component: <SearchDetails className={className} />, name: 'searchDetails' },
    { component: <SingleFamilyOffice className={className} />, name: 'single-family-office' },
    { component: <Share className={className} />, name: 'share' },
    { component: <ShareArrow className={className} />, name: 'share-arrow' },
    { component: <Taxi className={className} />, name: 'taxi' },
    { component: <Taxi2 className={className} />, name: 'taxi2' },
    { component: <TexBallonLeft className={className} />, name: 'texBallonLeft' },
    { component: <TexBallonRight className={className} />, name: 'texBallonRight' },
    { component: <TextList className={className} />, name: 'textList' },
    { component: <Time className={className} />, name: 'time' },
    { component: <Tick className={className} />, name: 'tick' },
    { component: <Train className={className} />, name: 'train' },
    { component: <Uber className={className} />, name: 'uber' },
    { component: <UberCareem className={className} />, name: 'uberCareem' },
    { component: <Venues className={className} />, name: 'venues' },
    { component: <AboutDubai className={className} />, name: 'about-dubai' },
    { component: <Accessibility className={className} />, name: 'accessibility' },
    {
      component: <Facilitiesavailableatdwtc className={className} />,
      name: 'facilities-available-at-dwtc',
    },
    { component: <Freezonelicenses className={className} />, name: 'freezone-licenses' },
    {
      component: <Generalenquiriesaboutthevenue className={className} />,
      name: 'general-enquiries-about-the-venue',
    },
    { component: <Hospitality className={className} />, name: 'hospitality' },
    { component: <Howtogettodwtc className={className} />, name: 'how-to-get-to-dwtc' },
    { component: <Hotels className={className} />, name: 'hotels' },
    {
      component: <Importantcontactsatdwtc className={className} />,
      name: 'important-contacts-at-dwtc',
    },
    { component: <Venueservices className={className} />, name: 'venue-services-for-exhibitions' },
    { component: <Weddings className={className} />, name: 'weddings' },
    { component: <Facebook className={className} />, name: 'facebook' },
    { component: <Linkedin className={className} />, name: 'linkedin' },
    { component: <Youtube className={className} />, name: 'youtube' },
    { component: <TwitterX className={className} />, name: 'twitter-x' },

    { component: <Faq1 className={className} />, name: 'icon-faq-1' },
    { component: <Faq2 className={className} />, name: 'icon-faq-2' },
    { component: <Faq3 className={className} />, name: 'icon-faq-3' },
    { component: <Faq4 className={className} />, name: 'icon-faq-4' },
    { component: <Faq5 className={className} />, name: 'icon-faq-5' },
    { component: <Faq6 className={className} />, name: 'icon-faq-6' },
    { component: <Faq7 className={className} />, name: 'icon-faq-7' },
    { component: <Faq8 className={className} />, name: 'icon-faq-8' },
    { component: <Faq9 className={className} />, name: 'icon-faq-9' },
    { component: <Faq10 className={className} />, name: 'icon-faq-10' },
    { component: <Faq11 className={className} />, name: 'icon-faq-11' },

    { component: <Toggle className={className} data-toggle={dataToggle} />, name: 'toggle' },
    { component: <Filter className={className} />, name: 'filter' },
    { component: <FilterBlack className={className} />, name: 'filter-black' },
    { component: <HubCompliance className={className} />, name: 'hub-compliance' },
    { component: <HubLegalServices className={className} />, name: 'hub-legal-services' },
    { component: <HubCallForwarding className={className} />, name: 'hub-call-forwarding' },
    { component: <HubMailManagement className={className} />, name: 'hub-mail-management' },
    { component: <HubProServices className={className} />, name: 'hub-pro-services' },
    { component: <HubAccountTax className={className} />, name: 'hub-account-tax' },
    { component: <HubGoldenVisa className={className} />, name: 'hub-golden-visa' },
    { component: <ShowMore className={className} />, name: 'show-more' },
    { component: <PersonHeadphone className={className} />, name: 'person-headphone' },
    { component: <EmailChat className={className} />, name: 'email-chat' },
    {
      component: <BusinessActivitiesLicenseType className={className} />,
      name: 'business-activities-license-type',
    },
    { component: <AccountingTax className={className} />, name: 'accounting-tax' },
    { component: <BankAccount className={className} />, name: 'bank-account' },
    { component: <CallForwading className={className} />, name: 'call-forwading' },
    { component: <CompilanceServices className={className} />, name: 'compliance-services' },
    { component: <GoldenVisa className={className} />, name: 'golden-visa' },
    { component: <LegalServices className={className} />, name: 'legal-services' },
    { component: <MailManagement className={className} />, name: 'mail-management' },
    { component: <ProServices className={className} />, name: 'pro-services' },
  ];

  // return name && componentsArr.find((value) => value.name === name).component;
  return name && componentsArr.some((el) => el.name === name)
    ? componentsArr.find((el) => el.name === name).component
    : null;
}
